module.exports = __webpack_public_path__ + "img/lqsxback_2.00836aa6.svg";